const notification = () => {
  return {
    show: false,
    text: null,
    timeout: 4000,
    color: 'info' // ['info', 'error', 'success', 'warning']
  }
}

export default {
  state: {
    loading: false,
    error: null,
    language: 'pt_BR',
    notification
  },
  getters: {
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    notification (state) {
      return state.notification
    },
    language (state) {
      return state.language
    }
  },
  // synchronuos
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setNotification (state, { text = null, timeout = 4000, type = 'info' }) {
      state.notification = {
        show: true,
        text,
        timeout,
        color: type // ['succes', 'info', 'error']
      }
    },
    clearError (state) {
      state.error = null
    },
    clearNotification (state) {
      state.notification = notification
    },
    setLanguage (state, payload) {
      state.language = payload
    },
    setSnackbar (state, payload) {
      state.snackbar = payload
    },
    closeSnackbar (state) {
      state.snackbar.show = false
    }
  },
  // asynchronous
  actions: {
    clearError ({ commit }) {
      commit('clearError')
    },
    clearNotification ({ commit }) {
      commit('clearNotification')
    },
    setNotification ({ commit }, payload) {
      commit('setNotification', payload)
    },
    setLanguage ({ commit }, payload) {
      commit('setLanguage', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/shared/index.js